import React, { useMemo } from 'react'
import { filterBlockByType } from '../../../services/common'
import { Parser } from '../../common'

const IllustratedContent = ({ block }) => {
    const blockContent = filterBlockByType(block.childrens, 'Contenu')
    const blockIllustration = filterBlockByType(block.childrens, 'Illustration')

    const illustrationPosition = block?.attributes?.positionIllustration

    const position = useMemo(() => {
        if (illustrationPosition === 'gauche') {
            return 'baseocom-flex baseocom-flex-col lg:baseocom-flex-row'
        }
        return 'baseocom-flex baseocom-flex-col lg:baseocom-flex-row-reverse'
    }, [illustrationPosition])

    return (
        <div className={`${position} baseocom-justify-between`}>
            <img
                className="baseocom-max-w-full baseocom-h-auto baseocom-block"
                src={blockIllustration?.attributes?.LienPublication}
                alt="Illustration de la fiche"
            />
            <div>
                <Parser content_block={blockContent?.childrens} />
            </div>
        </div>
    )
}

export default IllustratedContent
